var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 88,
    viewBox: "0 0 204 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0215 5.84813L0.1875 80.2532L11.1128 78.5651L44.077 73.4719L66.4927 0.573853L32.0215 5.84813Z",
    fill: "#F3F8FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4927 0.573853L44.077 73.4719L98.3268 82.5135V3.58773L66.4927 0.573853Z",
    fill: "#F3F8FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3268 3.58773V82.5135H158.604L134.87 3.58773H98.3268Z",
    fill: "#F3F8FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.87 3.58773L158.604 82.5135L200.799 81.4587L203.812 81.3834L169.153 3.58773H134.87Z",
    fill: "#F3F8FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3268 82.5135L44.077 73.4719L11.1128 78.5651L6.40362 87.5995L50.6699 79.688L98.3268 85.3391H202.494L200.799 81.4587L158.604 82.5135H98.3268Z",
    fill: "#F3F8FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3268 82.5135L44.077 73.4719L11.1128 78.5651L6.40362 87.5995L50.6699 79.688L98.3268 85.3391H202.494L200.799 81.4587L158.604 82.5135H98.3268Z",
    fill: "#F3F8FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3268 82.5135L44.077 73.4719L11.1128 78.5651L6.40362 87.5995L28.5368 83.6438L50.6699 79.688L98.3268 85.3391H202.494L200.799 81.4587L158.604 82.5135H98.3268Z",
    fill: "#F3F8FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.077 73.4719L98.3268 82.5135H158.604L200.799 81.4587L202.494 85.3391H98.3268L50.6699 79.688L28.5368 83.6438L6.40362 87.5995L11.1128 78.5651L27.5949 76.0185L44.077 73.4719Z",
    fill: "#F3F8FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3268 82.5135L44.077 73.4719L11.1128 78.5651L6.40362 87.5995L50.6699 79.688L98.3268 85.3391H202.494L200.799 81.4587L158.604 82.5135H98.3268Z",
    fill: "#D8D8D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3268 82.5135L44.077 73.4719L11.1128 78.5651L6.40362 87.5995L50.6699 79.688L98.3268 85.3391H202.494L200.799 81.4587L158.604 82.5135H98.3268Z",
    fill: "#D8D8D8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3268 82.5135L44.077 73.4719L11.1128 78.5651L6.40362 87.5995L28.5368 83.6438L50.6699 79.688L98.3268 85.3391H202.494L200.799 81.4587L158.604 82.5135H98.3268Z",
    fill: "#D8D8D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.077 73.4719L98.3268 82.5135H158.604L200.799 81.4587L202.494 85.3391H98.3268L50.6699 79.688L28.5368 83.6438L6.40362 87.5995L11.1128 78.5651L27.5949 76.0185L44.077 73.4719Z",
    fill: "#D8D8D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4927 0.573853L44.077 73.4719L98.3268 82.5136V3.58773L66.4927 0.573853Z",
    fill: "#E3EDF8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.87 3.58773L158.604 82.5136L200.799 81.4587L203.812 81.3834L169.153 3.58773H134.87Z",
    fill: "#EBF2FA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7235 18.2762C26.7235 18.2762 47.634 27.6519 64.7974 21.4827C74.9971 17.8165 80.9969 17.7153 87.0247 26.0035C108.528 55.5712 153.608 28.7884 169.234 37.0276C184.86 45.2669 185.428 81.8583 185.428 81.8583",
    stroke: "#F54286",
    strokeWidth: 3.76734
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.a4565983.svg";
export { ForwardRef as ReactComponent };